import React, { lazy, Suspense } from 'react';
import { NavLink, } from "react-router-dom";
import WSManager from "../../WSHelper/WSManager";
import * as WSC from "../../WSHelper/WSConstants";
import { logoutUser } from "../../WSHelper/WSCallings";
import { MyContext } from './../../InitialSetup/MyProvider';
import * as AppLabels from "../../helper/AppLabels";
import Images from '../../components/images';
import { withTranslation } from "react-i18next";
import * as Constants from "../../helper/Constants";
import { Utilities, isFooterTab, sendMessageToApp } from '../../Utilities/Utilities';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import CustomLoader from '../../helper/CustomLoader';
const SelectLanguage = lazy(() => import('../../Component/CustomComponent/SelectLanguage'));

class More extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subMenuOpen: false,
            profile: WSManager.getProfile(),
            userBalance: WSManager.getBalance(),
            allowLanguage: Constants.ALLOW_LANG,
            androidAppVersion: '-',
            showBecomeAM: false,
            isLoading: false

        }
    }

    userLogout = () => {
        this.setState({
            isLoading: true
        });
        let param = {
            Sessionkey: WSManager.getToken()
        }
        logoutUser(param).then((responseJson) => {
            if (responseJson.response_code == WSC.successCode) {
                WSManager.logout();
            }
            setTimeout(() => {
                this.setState({
                    isLoading: false
                });
            }, 200);
        })
    }

    redirectTo = (path) => {
        this.props.history.push(path);
    }

    componentDidMount() {
        Utilities.handleAppBackManage('more')
        WSManager.setIsFromPayment(false)
        setTimeout(() => {
            let app_version = {
                action: 'app_version',
                targetFunc: 'app_version',
                type: 'android',
            }
            sendMessageToApp(app_version)
            this.handelNativeData()
        }, 300);

    }

    handelNativeData() {
        window.addEventListener('message', (e) => {
            if (e.data.action === 'app_version' && e.data.type === 'android') {
                Utilities.setAndroidAppVersion('' + e.data.version)
                this.setState({ androidAppVersion: e.data.version })
            }
        });
    }

    updateNativeApp() {
        let app_version = {
            action: 'app_download',
            targetFunc: 'app_download',
            type: 'android',
            data: Utilities.getMasterData().app_version.android || {}
        }
        sendMessageToApp(app_version)
    }

    handleUpdateFeature = () => {
        if (!WSManager.getIsIOSApp() && Utilities.getMasterData().app_version.android && Utilities.getMasterData().app_version.android.current_ver != this.state.androidAppVersion) {
            return <div className='update-btn' onClick={() => this.updateNativeApp()}>{AppLabels.UPDATE}</div>
        }
    }

    // getApk = (fileUrl)=> {
    //     fetch(fileUrl, {
    //         method: 'GET',
    //         headers: new Headers({
    //             "Access-Control-Allow-Origin": "*"
    //         })
    //     })
    //     .then(response => response.blob())
    //     .then(blob => {
    //         var filename = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
    //         var _fileArr = filename.split('.');
    //         var _camData = Utilities.getCpSession();
    //         var _finalName = [_fileArr[0], _camData['campaign'], _camData['medium'], _camData['source'], _fileArr[1]].join('.')
    //         var url = window.URL.createObjectURL(blob);
    //         var a = document.createElement('a');
    //         a.href = url;
    //         a.download = _camData['source'] == '' ? filename : _finalName;
    //         document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
    //         a.click();
    //         a.remove();  //afterwards we remove the element again
    //         if(window.dataLayer) {
    //             window.dataLayer.push({
    //                 'event': 'download_apk',
    //                 'user_id': WSManager.getCookie('_id'),
    //                 'user_name': WSManager.getCookie('_nm'),
    //                 ...Utilities.getCpSession()
    //             })
    //         }
    //     });
    // }

    getApk = (fileUrl) => {
        var filename = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);

        let save = document.createElement('a');
        save.href = fileUrl;
        save.target = '_blank';

        save.download = filename;
        var evt = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': false
        });
        save.dispatchEvent(evt);
        (window.URL || window.webkitURL).revokeObjectURL(save.href);
        if (window.dataLayer) {
            window.dataLayer.push({
                'event': 'download_apk',
                'user_id': WSManager.getCookie('_id'),
                'user_name': WSManager.getCookie('_nm'),
                ...Utilities.getCpSession()
            })
        }
    }

    render() {

        return (
            <MyContext.Consumer>
                {(context) => (
                    <div className="web-container more-screen-container white-bg container-height pt20">
                        {this.state.allowLanguage && this.state.allowLanguage.length > 1 &&
                            <div className="language-section">
                                <Suspense fallback={<div />} ><SelectLanguage boxView={true} /></Suspense>
                            </div>
                        }
                        {
                            this.state.isLoading && <CustomLoader />
                        }
                        <ul className="drawer-menu-list">
                            {
                                Constants.SELECTED_GAMET != Constants.GameType.MultiGame &&
                                Utilities.getMasterData().private_contest === '1' &&
                                Constants.SELECTED_GAMET != Constants.GameType.Pred &&
                                <li className="drawer-menu-item">
                                    <NavLink exact to={"/create-contest"}>
                                        <i className="ic icon-trophy"></i>
                                        {AppLabels.Create_a_Contest}
                                    </NavLink>
                                </li>
                            }
                            {!isFooterTab('my-contests') &&
                                <li className="drawer-menu-item">
                                    <NavLink exact to="/my-contests">
                                        <i className="ic icon-cup"></i>
                                        {AppLabels.MY_CONTEST}
                                    </NavLink>
                                </li>
                            }
                            {!isFooterTab('my-profile') &&
                                <li className="drawer-menu-item">
                                    <NavLink exact to="/my-profile">
                                        <i className="ic icon-profile"></i>
                                        {AppLabels.PROFILE}
                                    </NavLink>
                                </li>
                            }
                            {!isFooterTab('my-wallet') &&
                                <li className="drawer-menu-item">
                                    <NavLink exact to="/my-wallet">
                                        <i className="ic icon-wallet-ic"></i>
                                        {AppLabels.MY_WALLET}
                                    </NavLink>
                                </li>
                            }
                            {!isFooterTab('refer-friend') &&
                                <li className="drawer-menu-item">
                                    <NavLink exact to="/refer-friend">
                                        <i className="ic icon-add-user"></i>
                                        {AppLabels.REFER_A_FRIEND_LOWER}
                                    </NavLink>
                                </li>
                            }
                            {Utilities.getMasterData().a_coin == "1" &&
                                <li className="drawer-menu-item">
                                    <NavLink exact to="/what-is-new">
                                        <i className="ic icon-megaphone font-22"></i>
                                        {AppLabels.WHATSNEW}
                                    </NavLink>
                                </li>
                            }
                            {Utilities.getMasterData().login_flow == '1' &&
                                <li className="drawer-menu-item">
                                    <NavLink exact to="/change-password">
                                        <i className="ic icon-add-user"></i>
                                        {AppLabels.CHANGE_PASSWORD}
                                    </NavLink>
                                </li>
                            }
                            <li className="drawer-menu-item">
                                <NavLink exact to="/feedback">
                                    <i className="ic icon-ic-info"></i>
                                    {AppLabels.FEEDBACK}
                                </NavLink>
                            </li>
                            <li className="drawer-menu-item">
                                <NavLink exact to="/earn-coins">
                                    <i className="ic icon-coins-bal-ic"></i>
                                    {AppLabels.EARN_COINS_LOWCASE}
                                </NavLink>
                            </li>
                            <li onClick={() => this.setState({ subMenuOpen: !this.state.subMenuOpen })} className={'drawer-menu-item' + (this.state.subMenuOpen ? ' bottom-border-hide' : '')}>
                                <NavLink exact to="#">
                                    <i className="ic icon-more-large"></i>
                                    {AppLabels.OTHERS}
                                    <i className={"ic arrow-right " + (this.state.subMenuOpen ? 'icon-arrow-up' : 'icon-arrow-down')}></i>
                                </NavLink>
                            </li>

                            <ul className={this.state.subMenuOpen ? 'sub-menu-open' : 'sub-menu-close'}>
                                <li className="drawer-menu-item">
                                    <NavLink exact to="/about-us">
                                        <i className="ic icon-ic-info fs24"></i>
                                        {AppLabels.ABOUT_US}
                                    </NavLink>
                                </li>
                                <li className="drawer-menu-item">
                                    <NavLink exact to="/faq">
                                        <i className="ic icon-question"></i>
                                        {AppLabels.FAQS}
                                    </NavLink>
                                </li>
                                <li className="drawer-menu-item">
                                    <NavLink exact to="/terms-condition">
                                        <i className="ic icon-file"></i>
                                        {AppLabels.TERMS_CONDITION}
                                    </NavLink>
                                </li>
                                <li className="drawer-menu-item">
                                    <NavLink exact to="/rules-and-scoring">
                                        <i className="ic icon-rules"></i>
                                        {AppLabels.RULES_AND_SCORING}
                                    </NavLink>
                                </li>
                                <li className="drawer-menu-item">
                                    <NavLink exact to="/privacy-policy">
                                        <i className="ic icon-lock"></i>
                                        {AppLabels.PRIVACY_POLICY}
                                    </NavLink>
                                </li>
                                <li className="drawer-menu-item">
                                    <NavLink exact to="/contact-us">
                                        <i className="ic icon-mail"></i>
                                        {AppLabels.CONTACT_US}
                                    </NavLink>
                                </li>
                                <li className="drawer-menu-item">
                                    <NavLink exact to="/legality">
                                        <i className="ic icon-legality-ic"></i>
                                        {AppLabels.LEGALITY}
                                    </NavLink>
                                </li>
                                <li className="drawer-menu-item">
                                    <NavLink exact to="/offers">
                                        <i className="ic icon-offers-ic"></i>
                                        {AppLabels.OFFERS}
                                    </NavLink>
                                </li>
                                <li className="drawer-menu-item">
                                    <NavLink exact to="/how-it-works">
                                        <i className="ic icon-question"></i>
                                        {AppLabels.HOW_IT_WORKS}
                                    </NavLink>
                                </li>
                                {
                                    window.navigator.userAgent.toLowerCase().includes('android') && navigator.userAgent.toLowerCase() != 'android-app' &&
                                    <li className="drawer-menu-item">
                                        <span onClick={() => this.getApk(Constants.APP_DOWNLOAD_LINK_ANDROID)}>
                                            <i className="ic icon-ic-download"></i>
                                            {AppLabels.DOWNLOAD_APP}
                                        </span>
                                        {/* <a href={Constants.APP_DOWNLOAD_LINK_ANDROID}>
                                            <i className="ic icon-ic-download"></i>
                                            {AppLabels.DOWNLOAD_APP}
                                        </a> */}
                                    </li>
                                }
                            </ul>

                        </ul>

                        <div className='more-footer'>
                            <div className="drawer-footer">
                                {
                                    Constants.SELECTED_GAMET != Constants.GameType.Pred && Constants.SELECTED_GAMET != Constants.GameType.MultiGame &&
                                    <span onClick={() => this.redirectTo('/private-contest')}>
                                        <span className="league-code-btn">
                                            <i className="icon-league-code" />
                                            {AppLabels.HAVE_A_LEAGUE_CODE}
                                        </span>
                                    </span>
                                }

                                <a href onClick={this.userLogout} className="logout-btn">
                                    <i className="icon-logout" />
                                    {AppLabels.LOGOUT}
                                </a>
                            </div>
                            <div className='bottom-container'>
                                {window.ReactNativeWebView &&
                                    <div className={"app-version-container "}>
                                        <div className='version-name'>Version {this.state.androidAppVersion}</div>
                                        {this.handleUpdateFeature()}
                                    </div>
                                }
                                {
                                    Constants.IS_BRAND_ENABLE && <div className={"developed-by-container " + (window.ReactNativeWebView ? " text-right" : "")}>
                                        <span>{AppLabels.TAGLINE}</span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                )}
            </MyContext.Consumer>
        );
    }
}

export default withTranslation()(More)